module.exports = __webpack_public_path__ + "img/VoiceNotesIcon.521e8e4e.png";